import { LAYOUT } from './layout';
import { formatVoltage } from '../../../utils/formatVoltage';

interface BusInfoBarProps {
  x: number;
  y: number;
  voltageV: number | null;
  frequencyHz: number | null;
  currentA: number | null;
}

export function BusInfoBar({ x, y, voltageV, frequencyHz, currentA }: BusInfoBarProps) {
  const w = LAYOUT.busInfoW;
  const h = LAYOUT.busInfoH;
  const cx = x + w / 2;

  const vStr = formatVoltage(voltageV, 'ac');
  const fStr = frequencyHz != null ? `${frequencyHz.toFixed(2)} Hz` : '— Hz';
  const aStr = currentA != null ? `${Math.round(currentA)} A` : '— A';

  return (
    <g>
      <rect
        x={x} y={y} width={w} height={h} rx={8}
        fill="#0c1524" stroke="#1e3a5f" strokeWidth={1}
      />
      <text x={cx} y={y + 22} textAnchor="middle" fill="#38bdf8" fontSize="13" fontWeight="600" fontFamily="monospace">
        {vStr}  |  {fStr}
      </text>
      <text x={cx} y={y + 40} textAnchor="middle" fill="#94a3b8" fontSize="12" fontFamily="monospace">
        {aStr}
      </text>
    </g>
  );
}
